import { makeStyles } from "@material-ui/core/styles";
import { coloresEmma } from "../../global/js/funciones";

/**
 * Estilos centralizados del módulo "Proyecto de vida".
 * Convención: aquí solo van las clases con 4 o más propiedades; las de 3 o menos
 * se dejan inline en su propio componente.
 * - Componentes de función: `const classes = useStyles();`
 * - Componente de clase (ProyectoVida): `withStyles(styles)` -> this.props.classes
 */
export const styles = (theme) => ({
  /* ===================== Compartidos ===================== */
  btnPrimario: {
    borderRadius: 10,
    padding: "10px 44px",
    textTransform: "none",
    fontWeight: 700,
    color: "#fff",
    backgroundColor: coloresEmma.primarycolor,
    "&:hover": { backgroundColor: coloresEmma.secondarycolor },
  },

  /* ===================== ProyectoVida (formulario) ===================== */
  formTituloRow: { display: "flex", alignItems: "center", gap: 10, marginBottom: 4 },
  formTituloBarra: { width: 5, height: 26, backgroundColor: coloresEmma.primarycolor, borderRadius: 4 },
  formCard: {
    position: "relative",
    cursor: "pointer",
    borderRadius: 16,
    padding: "24px 20px",
    minHeight: 130,
    backgroundSize: "cover",
    backgroundPosition: "center",
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    transition: "transform 0.15s, box-shadow 0.15s",
    display: "flex",
    alignItems: "center",
    gap: 16,
    "&:hover": {
      transform: "translateY(-3px)",
      boxShadow: "0 6px 16px rgba(0,0,0,0.15)",
    },
  },
  formCardLogoWrap: { position: "relative", width: 68, height: 68, flexShrink: 0 },
  formCardBubble: {
    width: 68,
    height: 68,
    borderRadius: "50%",
    backgroundColor: "#ffffff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 4px 10px rgba(0,0,0,0.12)",
  },
  formCardLines: { position: "absolute", top: -8, right: -12, width: 26, height: 26, objectFit: "contain" },
  formCardFlecha: {
    position: "absolute",
    bottom: 16,
    right: 16,
    width: 34,
    height: 34,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
  },
  formCardCheck: {
    position: "absolute",
    top: 10,
    right: 10,
    width: 24,
    height: 24,
    borderRadius: "50%",
    backgroundColor: "#2e7d32",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 1px 4px rgba(0,0,0,0.25)",
    opacity: 0.7,
  },
  listoTip: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    marginTop: 24,
    padding: "14px 18px",
    backgroundColor: "#fdecec",
    borderRadius: 12,
    textAlign: "left",
  },

  /* ===================== ProyectoVidaModal ===================== */
  encabezado: { display: "flex", alignItems: "center", gap: 16, marginBottom: theme.spacing(2) },
  logoWrapper: { position: "relative", width: 64, height: 64, flexShrink: 0 },
  logoBubble: {
    width: 64,
    height: 64,
    borderRadius: "50%",
    backgroundColor: "#ffffff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 4px 10px rgba(0,0,0,0.12)",
  },
  lines: { position: "absolute", top: -8, right: -12, width: 24, height: 24, objectFit: "contain" },
  contador: { textAlign: "right", color: "#9e9e9e", fontSize: "0.75rem", marginTop: 4 },
  consejo: {
    display: "flex",
    alignItems: "flex-start",
    gap: 12,
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: "#fdecec",
    borderRadius: 12,
  },
  btnCancelar: {
    borderRadius: 10,
    padding: "10px 34px",
    textTransform: "none",
    fontWeight: 700,
    color: coloresEmma.secondarycolor,
    borderColor: coloresEmma.secondarycolor,
  },

  /* ===================== ProyectoVidaDetalle ===================== */
  barraSuperior: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: 12,
    marginBottom: 16,
    flexWrap: "wrap",
  },
  btnEditar: {
    borderRadius: 10,
    textTransform: "none",
    fontWeight: 700,
    color: "#fff",
    backgroundColor: coloresEmma.primarycolor,
    padding: "8px 22px",
    "&:hover": { backgroundColor: coloresEmma.secondarycolor },
  },
  poster: { display: "flex", gap: 24, alignItems: "stretch", flexWrap: "wrap" },
  panelIzq: {
    flex: "0 0 300px",
    maxWidth: 320,
    backgroundColor: "#f6f4f5",
    borderRadius: 16,
    padding: "32px 26px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    [theme.breakpoints.down("xs")]: {
      flex: "1 1 100%",
      maxWidth: "100%",
    },
  },
  fotoWrapper: { position: "relative", width: 150, height: 150, marginBottom: 20 },
  foto: {
    width: 150,
    height: 150,
    borderRadius: "50%",
    objectFit: "cover",
    border: "5px solid #f7d9c9",
    backgroundColor: "#fff",
  },
  fotoLines: { position: "absolute", top: -6, right: -8, width: 34, height: 34, objectFit: "contain" },
  nombre: {
    fontWeight: 800,
    color: "#2b2b2b",
    textTransform: "uppercase",
    lineHeight: 1.15,
    fontSize: "1.7rem",
    textAlign: "left",
    [theme.breakpoints.down("xs")]: { width: "100%", textAlign: "center" },
  },
  divisor: {
    width: 46,
    height: 3,
    backgroundColor: coloresEmma.secondarycolor,
    borderRadius: 3,
    margin: "16px auto 16px 0px",
    [theme.breakpoints.down("xs")]: { margin: "16px auto" },
  },
  programas: {
    color: coloresEmma.secondarycolor,
    fontWeight: 700,
    fontSize: "1rem",
    lineHeight: 1.4,
    textAlign: "left",
    [theme.breakpoints.down("xs")]: { width: "100%", textAlign: "left" },
  },
  fraseWrapper: {
    display: "flex",
    gap: 8,
    marginTop: 22,
    marginBottom: 22,
    textAlign: "left",
    [theme.breakpoints.down("xs")]: { justifyContent: "center" },
  },
  fraseIcono: { color: coloresEmma.secondarycolor, fontSize: 30, lineHeight: 1, transform: "scaleX(-1)" },
  frase: {
    color: "#555",
    fontStyle: "italic",
    fontSize: "0.95rem",
    lineHeight: 1.5,
    [theme.breakpoints.down("xs")]: { textAlign: "center" },
  },
  card: {
    position: "relative",
    // un poco más oscuro que el fondo blanco de la vista, pero más claro que el panel izquierdo (#f6f4f5)
    backgroundColor: "#fafafa80",
    border: "1px solid #e3e3e3",
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    borderRadius: 14,
    // padding-top amplio para dejar sitio a la burbuja que sobresale
    padding: "50px 20px 26px 20px",
    minHeight: 240,
    overflow: "visible",
    textAlign: "center",
    height: "100%",
    boxSizing: "border-box",
    marginTop: 14,
  },
  burbuja: {
    position: "absolute",
    top: -15, // sobresale por el borde superior de la card
    left: "50%",
    transform: "translateX(-50%)",
    width: 74,
    height: 74,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  tituloSeccion: { fontWeight: 800, textTransform: "uppercase", lineHeight: 1.15, marginTop: 30 },
  divisorSeccion: { width: 40, height: 3, borderRadius: 3, margin: "10px auto 15px auto" },
  textoSeccion: {
    color: "#4a4a4a",
    fontSize: "0.9rem",
    lineHeight: 1.5,
    textAlign: "left",
    whiteSpace: "pre-wrap",
    position: "relative",
    zIndex: 1,
  },
  ola: {
    position: "absolute",
    left: 0,
    bottom: 0,
    width: "100%",
    height: "auto",
    display: "block",
    borderBottomLeftRadius: 14,
    borderBottomRightRadius: 14,
    opacity: 0.4,
    pointerEvents: "none",
    zIndex: 0,
  },

  /* ===================== Gestión (Consulta y seguimiento) ===================== */
  filtrosCard: {
    border: "1px solid #e3e3e3",
    borderRadius: 12,
    padding: "20px 22px",
    backgroundColor: "#fff",
    marginTop: 4,
  },
  filtrosRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: 16,
    alignItems: "flex-end",
  },
  filtrosAcciones: {
    display: "flex",
    gap: 12,
    alignItems: "flex-end",
    marginLeft: "auto",
  },
  thGestion: {
    fontWeight: 700,
    color: "#555",
    backgroundColor: "#f5f5f5",
    fontSize: "0.8rem",
  },
  avatarIniciales: {
    width: 34,
    height: 34,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    fontWeight: 700,
    fontSize: "0.8rem",
    flexShrink: 0,
  },
  badgeSemestre: {
    display: "inline-block",
    padding: "2px 10px",
    borderRadius: 10,
    backgroundColor: "#eceff1",
    color: "#607d8b",
    fontSize: "0.75rem",
    fontWeight: 700,
  },

  /* ===================== Gestión (Análisis de información) ===================== */
  analisisCardsRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: 16,
    marginTop: 20,
  },
  analisisCard: {
    flex: 1,
    minWidth: 220,
    display: "flex",
    alignItems: "center",
    gap: 16,
    padding: "18px 20px",
    border: "1px solid #eee",
    borderRadius: 14,
    backgroundColor: "#faf7f8",
    boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
  },
  analisisCardIcon: {
    width: 54,
    height: 54,
    borderRadius: 14,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  nubeCard: {
    marginTop: 24,
    border: "1px solid #eee",
    borderRadius: 14,
    backgroundColor: "#fff",
    overflow: "hidden",
  },
  nubeTab: {
    flex: 1,
    minWidth: 140,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    padding: "14px 10px",
    cursor: "pointer",
    fontWeight: 600,
    fontSize: "0.9rem",
    color: "#777",
    borderBottom: "3px solid transparent",
    transition: "color 0.15s, border-color 0.15s",
    "&:hover": { color: "#444" },
  },
  nubeArea: {
    minHeight: 340,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: 24,
  },
});

export const useStyles = makeStyles(styles);
